// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-LFSZ","toggle":"styles_toggle__FlM4l","preview":"styles_preview__1Vofd"};